import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const authUserSelector = createSelector(
  (state: any) => state.global,
  (global: any) => global.authUser
);

const useAuth = () => useSelector(authUserSelector);

export default useAuth;
